import { PublicPageLayoutSizeEnum } from '@/types/PublicPageLayoutSize';
import { PublicPageLayoutEnum } from '../PublicPageLayout';
import UserResp from './UserResp';

export default class PublicPageResp {
    id!: number;
    //バグの元になるので多重情報はできるだけやりとりしたくないが、RespにはProjectIDを含めるで統一。識別のため名前を少し変更。
    baseProjectId!: number;

    htmlPath!: string;
    title!: string;
    titleURL!: string;
    description!: string;

    commentsCount!: number;

    user!: UserResp;
    hasLoginUserGood!: boolean;

    anonymousGoodCount!: number;
    goodCount!: number;
    viewCount!: number;

    thumbnail!: string;

    layout!:PublicPageLayoutEnum;
    layoutSize!:PublicPageLayoutSizeEnum;
    layoutSizeX!:number|null;
    layoutSizeY!:number|null;
    layoutZoom!:boolean;
    layoutBorder!:boolean;

    isOpenSrc!:boolean;

    createdAt!: string;
    
	constructor(json:Object){
        Object.assign(this, json);
    }
}

